import { ShopifyEvents } from '../../types/shopify'
import { SHOPIFY_EVENTS } from '../../utils/constants'

class ShopifyEditor {
  listeners: { [key in ShopifyEvents]?: any }

  constructor() {
    this.listeners = {}
  }

  subscribe(eventName: ShopifyEvents, listener: any): void {
    if (!this.listeners[eventName]) {
      this.listeners[eventName] = []
    }

    document.addEventListener(SHOPIFY_EVENTS[eventName], listener)

    this.listeners[eventName].push(listener)
  }

  unsubscribe(eventName: ShopifyEvents, removedListener: any): void {
    if (!this.listeners[eventName]) {
      return
    }

    document.removeEventListener(SHOPIFY_EVENTS[eventName], removedListener)

    this.listeners[eventName] = this.listeners[eventName].filter(
      listener => listener !== removedListener,
    )
  }

  destroy(): void {
    const events = Object.keys(this.listeners)

    events.forEach(event => {
      const listeners = this.listeners[event]

      listeners.forEach(listener => {
        this.unsubscribe(event as ShopifyEvents, listener)
      })
    })

    this.listeners = {}
  }
}

export default ShopifyEditor
